module.exports = __webpack_public_path__ + "static/media/vibino-feature-icon-pic4.c17f9c48.jpg";